export default {
  plugMidiKeyboardPanel: {
    title: 'conseils',
    subtitle: 'branchez votre clavier pour beneficier de tout ce que tokatab peut vous offrir !',
    learnMore: 'En savoir plus',
    close: 'Fermer',
    dontRemindMe: 'Ne plus me le rappeller',
  },
  savoirPlusMidiKeyboardPanel: {
    title: 'en savoir plus',
    subtitle: 'questions les plus fréquentes',
    question1: 'Qu\'est ce qu\'un clavier compatible MIDI et à quoi ça sert ?',
    answer1Part1: 'Un clavier compatible midi est un clavier que vous pouvez utiliser pour controller un instrument virtuel présent dans votre appareil.',
    answer1Part2: 'Avec Tokatab, il permettra d\'évaluer votre jeu, de rendre l\'utilisation plus ludique et notre assistance plus précise !',
    answer1Part3: 'Tokatab intègre un piano virtuel, il vous suffit de brancher votre clavier et de profiter de l\'expérience !',
    question2: 'Comment reconnaitre un clavier MIDI et comment le brancher ?',
    question3: 'Ou acheter un cable ?',
    ok: 'ok',
    dontRemindMe: 'Ne plus me le rappeller',
  },
  plugMidiKeyboardBar: {
    shortMessage: 'Branchez votre clavier pour profiter de Tokatab !',
    longMessage: 'Branchez votre clavier pour profiter de la meilleure expérience possible sur Tokatab !',
    learnMore: 'En savoir plus',
  },
};
